export const BERTH_TYPE = 'berth_type'
export const SHIP_TYPE = 'ship_type'
export const ACTUAL_BERTHING_ORIENTATION = 'actual_berthing_orientation'
export const MOORING_SIDE = 'mooring_side'
export const HIGH_LOW_WATER = 'high_low_water'
export const HIGH_WATER_LEVEL = 'high_water_level'
export const LOW_WATER_LEVEL = 'low_water_level'
export const WATER_LEVEL = 'water_level'
export const MOORING_POINT_LEVEL = 'mooring_point_level'
export const BERTHING_POINT_LEVEL = 'berthing_point_level'
export const MAXIMUM_NUMBER_OF_LINES = 'maximum_number_of_lines'
export const MIN_LINE_LENGTH = 'min_line_length'
export const QUAY_LEVEL = 'quay_level'
export const MOORING_POINT_Y = 'mooring_point_y'
export const BERTHING_POINT_Y = 'berthing_point_y'
export const START_MOORING_POINT_X = 'start_mooring_point_x'
export const MOORING_POINT_SPACING = 'mooring_point_spacing'
export const X1 = 'x1'
export const X2 = 'x2'
export const Y_LOCATION_PLATFORM = 'y_location_platform'
export const PLATFORM_WIDTH = 'platform_width'
export const PLATFORM_LENGTH = 'platform_length'
export const DESCRIPTION = 'description'
export const NAME = 'name'
